module.exports = __webpack_public_path__ + "img/group3.baa482c8.svg";